((Drupal, once) => {
  class Cookiebanner {
    body;
    banner;
    categories;
    observer;
    agreeButton;
    savePreferencesButton;
    openPreferencesButton;
    spacing = 30;

    constructor(element) {
      this.banner = element;
      this.body = document.querySelector('body');
      this.agreeButton = this.banner.querySelector('.agree-button');
      this.savePreferencesButton = this.banner.querySelector(
        '.button--cookie-preferences',
      );
      this.openPreferencesButton = this.banner.querySelector(
        '.button--cookie-open-preferences',
      );
      this.categories = this.banner.querySelector(
        '.eu-cookie-compliance-categories',
      );
      this.initialize();
    }

    initialize() {
      if (this.banner.offsetTop < 0) {
        return;
      }

      this.observeSize();
      this.openPreferencesButton.addEventListener(
        'click',
        this.openPreferences.bind(this),
      );
      this.agreeButton.onClick = () => this.removeObservations.bind(this);
      this.savePreferencesButton.onClick = () =>
        this.removeObservations.bind(this);
    }

    openPreferences() {
      this.categories.classList.add('eu-cookie-compliance-categories--active');
    }

    observeSize() {
      this.observer = new ResizeObserver((mutations) => {
        for (const mutation of mutations) {
          let bannerHeight = mutation.contentRect.height;

          bannerHeight <= 0
            ? this.setBodySpacing(0)
            : this.setBodySpacing(bannerHeight + this.spacing);
        }
      });

      this.observer.observe(this.banner);
    }

    setBodySpacing(spacing) {
      this.body.style.paddingTop = `${+spacing}px`;
    }

    removeObservations() {
      this.setBodySpacing(0);
      this.observer.disconnect();
    }
  }

  Drupal.behaviors.cookie_banner = {
    attach: (context, settings) => {
      setTimeout(() => {
        const cookieBanner = once(
          'cookie_banner',
          '.sliding-popup-top',
          context,
        );

        cookieBanner[0] && new Cookiebanner(cookieBanner[0]);
      }, 100);
    },
  };
})(Drupal, once);
